const _excluded = ["legalDisclaimer", "style", "renderCdxFooter"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import Cookies from 'js-cookie';
import { GlobalFooter as GlobalFooter$2 } from '@cb/components';
import { useLocaleContext, GlobalFooter as GlobalFooter$1, ErrorBoundary, SectionComponentLayout, Div, LegalDisclaimer } from '@cbhq/cdx-components';
import { localeCodeToDisplayName, langPickerSupportedLocales } from '../globals/locales.js';
import { getLocaleCodeWithoutRegion, getRegionCodeFromLocale } from '../utils/splitLocale.js';
import { jsx, jsxs } from 'react/jsx-runtime';

// eslint-disable-next-line no-restricted-imports -- TODO Fix this
const customComponentsThemeMap = {
  default: {
    background: 'background'
  },
  dark: {
    background: 'foreground'
  }
};
function GlobalFooter(_ref) {
  let legalDisclaimer = _ref.legalDisclaimer,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'default' : _ref$style,
    _ref$renderCdxFooter = _ref.renderCdxFooter,
    renderCdxFooter = _ref$renderCdxFooter === void 0 ? false : _ref$renderCdxFooter,
    cdxFooterProps = _objectWithoutProperties(_ref, _excluded);
  const _useLocaleContext = useLocaleContext(),
    locale = _useLocaleContext.locale,
    defaultLoggedOutConfig = _useLocaleContext.defaultLoggedOutConfig,
    fallbackLoggedOutConfig = _useLocaleContext.fallbackLoggedOutConfig;
  const countryFromIp = Cookies.get('ip_country')?.toUpperCase() || 'US';
  const localeCode = getLocaleCodeWithoutRegion(locale);
  const countryFromUrl = getRegionCodeFromLocale(locale, defaultLoggedOutConfig, fallbackLoggedOutConfig);
  const localeInformation = {
    selectedLocaleCode: locale,
    localeCodeToDisplayName,
    supportedLocales: langPickerSupportedLocales
  };
  const background = customComponentsThemeMap[style].background;
  return renderCdxFooter ? /*#__PURE__*/jsx(GlobalFooter$1, _objectSpread({
    legalDisclaimer: legalDisclaimer
  }, cdxFooterProps)) : /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsxs(SectionComponentLayout, {
      as: "footer",
      hasSpacingHorizontal: true,
      background: background,
      children: [/*#__PURE__*/jsx(Div, {
        spacingVertical: 6,
        justifyContent: "start",
        children: legalDisclaimer && /*#__PURE__*/jsx(LegalDisclaimer, {
          legalDisclaimer: legalDisclaimer
        })
      }), /*#__PURE__*/jsx(GlobalFooter$2, {
        userLocaleInfo: {
          localeCode: locale,
          countryFromUrl,
          countryFromIp,
          languageCode: localeCode,
          localeFromUrl: locale
        },
        localeInformation: localeInformation
      })]
    })
  });
}
export { GlobalFooter };
//# sourceMappingURL=GlobalFooter.js.map
